import styled from 'styled-components'

export const MappedChannelsComponentContainer = styled.div`
    width: 100%;
    .mapped-channels-search {
        width: calc(100%);
    }

    .source-setup-button {
        border: none;
        outline: none;
        background: none;
        color: var(--blue-500);
    }

    .disabled {
        pointer-events: none;
        cursor: default;
        color: var(--gray-700);
    }

    .custom-list-mapped-channels-list {
    }

    .custom-list-mapped-channels-list-edit-mode {
        background-color: transparent;
    }

    .custom-list-table-head {
        background-color: var(--gray-100);
    }

    .custom-list-column-name {
        width: 316px;
    }

    .no-channel-assigned {
        padding: 20px;
    }

    .custom-list-column-name {
        padding: 0 0 0 20px;
    }

    table {
        width: 100%;
    }

    .filteredSearch-input {
        padding: 0 12px;
    }
`

export const BottomRowContainer = styled.div`
    display: flex;
    /* background-color: var(--gray-300); */
    padding: 16px 20px;
    justify-content: space-between;
    width: 100%;

    .new-channel-container {
        display: flex;
        width: 100%;
        max-width: 445px;

        .new-channel-button {
            border: none;
            outline: none;
            background: none;
            color: var(--blue-500);
            width: 100px;
        }

        .select-channel {
            width: 296px;
        }
    }

    .add-channel-button {
        border: none;
        outline: none;
        background: none;
        color: var(--blue-500);
        width: 100px;
    }
`
